import { render, staticRenderFns } from "./utility-plugin-message.vue?vue&type=template&id=c5d8b3c0&scoped=true&"
import script from "./utility-plugin-message.vue?vue&type=script&lang=js&"
export * from "./utility-plugin-message.vue?vue&type=script&lang=js&"
import style0 from "./utility-plugin-message.vue?vue&type=style&index=0&id=c5d8b3c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d8b3c0",
  null
  
)

export default component.exports